import { ApplicationRole } from '@/types/application-role';
import { useSelectOptions } from './use-select-options';

export const useRoleSelectOptions = (roles: ApplicationRole[]) =>
  useSelectOptions<number, ApplicationRole, 'roleName', 'id'>(
    roles,
    'roleName',
    'id',
  );
